/*jshint esversion: 6 */
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const Divider = (function($) {

  const _s = {
    container: '.wp-block-indp-divider'
  };

  const _init = function() {
    if ($(_s.container).length === 0) {
      return;
    }

    _initAnimations();
  };

  // ===================
  // Initialize GSAP Animations
  const _initAnimations = function() {
    const dividers = document.querySelectorAll(_s.container);
    
    dividers.forEach((divider) => {
      const lineMaxWidth = divider.getAttribute('data-line-max-width') || 435;
      
      // Calculate the percentage that the max width represents
      const dividerWidth = divider.offsetWidth;
      const maxWidthPercent = Math.min((lineMaxWidth / dividerWidth) * 100, 100);
      
      // Set the CSS variable for max width
      divider.style.setProperty('--line-max-width', `${lineMaxWidth}px`);
      
      // Create timeline for coordinated animations
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: divider,
          start: 'top 80%',
          end: 'top 50%',
          scrub: 1,
        }
      });
      
      // Animate line width and opacity
      tl.to(divider, {
        '--line-width': maxWidthPercent,
        '--line-opacity': 1,
        duration: 1,
        ease: 'power2.out'
      }, 0);
      
      // Animate star position and opacity
      tl.to(divider, {
        '--star-offset': maxWidthPercent,
        '--star-opacity': 1,
        duration: 1,
        ease: 'power2.out'
      }, 0);
    });
  };

  return {
    container: _s.container,
    init: _init
  };

})(jQuery);

export default Divider;
